<template>
	<el-popover @hide="hide" @show="show" :disabled="popoverDisabled"
		:popper-options="{ boundariesElement: 'body', removeOnDestroy: false }" :ref="popoverRef" v-model="visible"
		:placement="placement" :width="width" :trigger="trigger" :append-to-body="true">
		<div style="padding: 10px;background-color: white;overflow: auto;">
			<div v-if="moduleName==''" :ref="containerId+'_ref'" :id="containerId+'_id'" style="margin-bottom: 10px;">
			</div>

			<vxe-grid v-bind="gridOptions" :key="gridKey" v-if="gridOptions && moduleName!=''" :ref="ref"></vxe-grid>
			<vxe-button v-if="buttons.indexOf('confirm')!=-1" status="success" size="mini" content="确认" @click="submit">
			</vxe-button>
			<vxe-button v-if="buttons.indexOf('cancle')!=-1" status="danger" size="mini" content="返回" @click="close">
			</vxe-button>
		</div>
		<template>
			<el-button v-if="el" v-show="buttonShow" slot="reference" :size="size">
				<i :class="icon" v-if="!popoverDisabled"></i>
				<i class="el-icon-lock" v-else></i>
			</el-button>
			<vxe-button v-if="!el" v-show="buttonShow" slot="reference" :status="buttonsStatus" :size="size">{{text}}
			</vxe-button>
		</template>
	</el-popover>
</template>
<script>
	export default {
		props: {
			store: {
				type: Object,
				default: () => {
					return {}
				}
			},
			selectType: {
				type: String,
				default: () => {
					return 'radio'
				}
			},
			width: {
				type: Number,
				default: () => {
					return 400
				}
			},
			height: {
				type: Number,
				default: () => {
					return 400
				}
			},
			trigger: {
				type: String,
				default: () => {
					return 'click'
				}
			},
			moduleName: {
				type: String,
				default: () => {
					return ''
				}
			},
			text: {
				type: String,
				default: () => {
					return '查询'
				}
			},
			size: {
				type: String,
				default: () => {
					return 'mini'
				}
			},
			type: {
				type: String,
				default: () => {
					return 'text'
				}
			},
			el: {
				type: Boolean,
				default: () => {
					return true
				}
			},
			placement: {
				type: String,
				default: () => {
					return 'bottom-start'
				}
			},
			buttons: {
				type: Array,
				default: () => {
					return ['confirm', 'cancle']
				}
			},
			parentControll: {
				type: Object,
				default: () => {
					return null
				}
			},
			icon: {
				type: String,
				default: () => {
					return 'el-icon-search'
				}
			},
			buttonsStatus: {
				type: String,
				default: () => {
					return 'primary'
				}
			},
			index: {
				type: Number,
				default: () => {
					return 0
				}
			}
		},
		data() {
			return {
				gridKey: Math.random(),
				gridOptions: null,
				visible: false,
				ref: Math.random(),
				popoverRef: Math.random(),
				foreingKey: {},
				containerId: 'box_' + Math.random(),
				buttonShow: true
			}
		},
		created() {
			if (this.moduleName != '') {
				this.initList()
			}

		},
		mounted() {
			if (this.store.box) {
				this.store.box[this.index] = this
			} else {
				let arr = []
				arr[0] = this
				this.store.box = arr
			}

			//this.store.table = this.$refs[this.ref]
		},
		methods: {
			initList() {
				console.log(this.moduleName)
				this.$api[this.moduleName].init({
					mode: 'box'
				}).then((res) => {
					let gridOptions = this.getOption()
					gridOptions.proxyConfig = {
						autoLoad: false,
						form: true,
						ajax: {
							query: ({
								page,
								form
							}) => {
								for (let i in form) {
									if (Array.isArray(form[i])) {
										form[i] = form[i].join(',')
									}
								}

								if (this.beforeRequest) {
									this.beforeRequest(form)
								}
								return new Promise(resolve => {
									this.$api[this.moduleName].list({
										mode: 'box',
										...page,
										...form,
										...this.foreingKey
									}).then((res) => {
										if (this.beforeRender) {
											this.beforeRender(res)
										}
										resolve({
											result: res.list,
											page: {
												total: res.total
											},
										})
									}, () => {
										resolve()
									})
								})
							}
						}
					}
					gridOptions.columns = this.getColumns(res.columns)
					gridOptions.formConfig = this.getForm(res.columns)
					gridOptions.radioConfig = {
						labelField: gridOptions.columns[0] ? gridOptions.columns[0].field : '',
						trigger: 'row'
					}
					gridOptions.checkboxConfig = {
						labelField: gridOptions.columns[0] ? gridOptions.columns[0].field : '',
						trigger: 'row',
						checkMethod: this.checkMethod,
						visibleMethod: this.visibleMethod
					}
					if (this.beforeCreateGrid) {
						this.beforeCreateGrid(gridOptions.formConfig, gridOptions.columns, gridOptions)
					}
					this.gridOptions = gridOptions
					this.ready()
				})
			},
			getOption() {
				return {
					border: true,
					size: 'mini',
					maxHeight: this.height,
					tooltipConfig: {
						showAll: true
					},
					treeConfig: {
						transform: true,
						rowField: 'id',
						parentField: 'parentid',
						line: false,
						expandAll: false,
					},
					columnConfig: {
						isHover: false,
						resizable: true
					},
					rowConfig: {
						isHover: true,
						isCurrent: true
					},


					pagerConfig: {
						currentPage: 1,
						pageSize: 20,

					},
					proxyConfig: {},

				}
			},
			getForm(data) {
				let items = []
				data.forEach((item) => {
					if (item.render) {
						items.push({
							field: item.field,
							title: item.title,
							folding: items.length >= 4,
							size: 'mini',
							span: '6',
							itemRender: {
								name: item.render,
								options: [],
								optionProps: {

								},
								props: {
									name: item.name,
									size: 'small',
									placeholder: '',
									...item.props
								},
							},
						})
					}
				})
				if (items.length != 0) {
					items.push({
						align: 'center',
						span: '6',
						itemRender: {
							name: '$buttons',
							children: [{
								props: {
									type: 'submit',
									content: '查询',
									status: 'primary'
								}
							}, {
								props: {
									type: 'reset',
									content: '重置'
								}
							}]
						}
					})
				}
				return {
					titleWidth: '80',
					titleAlign: 'center',
					items: items
				}
			},
			getColumns(data) {
				let columns = []
				data.forEach((item, index) => {
					columns.push({
						type: index == 0 ? this.selectType : '',
						width: item.width ? item.width : '',
						field: item.field,
						title: item.title,
						formatter: item.formatter ? new Function('return ' + item.formatter)() : null,
						visible: item.visible,
						treeNode: item.treeNode
					})
				})
				return columns
			},
			show() {
				let fullData = this.getTable().getTableData().fullData
				if (fullData.length == 0) {
					this.getTable().commitProxy('query')
				}

			},
			reload() {
				this.gridKey = Math.random()
			},
			setComponent(component) {
				this.component = component
				document.getElementById(this.containerId + '_id').appendChild(component.$el)
			},
			setForeingKey(foreingKey) {
				this.foreingKey = foreingKey
				this.reload()
			},
			getTable() {
				return this.$refs[this.ref]
			},
			close() {
				this.visible = false
				this.$refs[this.ref].clearCheckboxRow()
			},
			ready() {

			},
			checkMethod() {
				return true
			},
			visibleMethod() {
				return true
			},
		},
	}
</script>
